(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-section"] && !Shopify.designMode) return;
  try {
    function initFaqSection(faqSection) {
  const title = faqSection.querySelector('.faq-section__title');
  title.addEventListener('click', (e) => {
    const content = title.nextElementSibling;
    const isOpen = title.classList.contains('is-open');
    if (isOpen) {
      title.classList.remove('is-open');
      content.style.maxHeight = null;
    } else {
      title.classList.add('is-open');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
}
document.querySelectorAll('.faq-section').forEach((faqSection) => {
  initFaqSection(faqSection);
});
  } catch(e) { console.error(e); }
})();

})();
